module.exports = __webpack_public_path__ + "img/hyu_main0.41300e70.jpg";